import React from "react";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <footer className="sticky-footer bg-white">
            <div className="container my-auto">
                <div className="copyright text-center my-auto">
                    <span>Copyright &copy; SQRTECH {currentYear}</span>
                </div>
            </div>
        </footer>
    );

};
export default Footer;